import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope } from '../../models/auth.dto';
import { ApiKeyIssuedResponse, ApiKeyResponse, CreateApiKeyRequest } from '../../models/api-key.dto';

@Injectable({ providedIn: 'root' })
export class ApiKeyService {
  private apiUrl = environment.cbdx_service.api_path;

  constructor(private http: HttpClient) {}

  list(): Observable<ApiEnvelope<ApiKeyResponse[]>> {
    return this.http.get<ApiEnvelope<ApiKeyResponse[]>>(`${this.apiUrl}/companies/me/api-keys`);
  }

  create(request: CreateApiKeyRequest): Observable<ApiEnvelope<ApiKeyIssuedResponse>> {
    return this.http.post<ApiEnvelope<ApiKeyIssuedResponse>>(`${this.apiUrl}/companies/me/api-keys`, request);
  }

  revoke(id: string): Observable<ApiEnvelope<ApiKeyResponse>> {
    return this.http.delete<ApiEnvelope<ApiKeyResponse>>(`${this.apiUrl}/companies/me/api-keys/${id}`);
  }
}
